import SVG from "react-inlinesvg";
// import Sponsor from "@/component/Sponsor";
import { getDataFromSSR } from "@/handlers/client/commonClient";
import dynamic from "next/dynamic";
import { useRouter } from "next/router";
import { useCallback, useContext, useEffect, useMemo, useState } from "react";

import { MasterConfigContext } from "@/context/MasterConfigContext";

import {
  apstagBidCallback,
  createApsSlotsRosDesktop,
  createApsSlotsRosMobile,
  requestBiddingFromPWT,
} from "@/utils/ads";

const StatesConstituencyLiveResult = dynamic(() => import("./StatesConstituencyLiveResult"));
const ElectionMainTab = dynamic(() => import("./ElectionMainTab"));
const FaqSchema = dynamic(() => import("./FaqSchema"));
const ExitPollTally = dynamic(() => import("./ExitPollTally"));
const StateResultTally = dynamic(() => import("@/component/StateResultTally"));
const NoData = dynamic(() => import("@/component/NoData"));
const Breadcrumb = dynamic(() => import("@/component/Breadcrumb"));
const ItemsListSchema = dynamic(() => import("@/component/SeoTags/ItemsList"));
const List1 = dynamic(() => import("@/component/Listing/List1"));
const List2 = dynamic(() => import("@/component/Listing/List2"));
const BreadcrumbSchema = dynamic(() =>
  import("@/component/SeoTags/BreadcrumbSchema")
);
const WebpageSchema = dynamic(() =>
  import("@/component/SeoTags/WebpageSchema")
);
const HeadTag = dynamic(() => import("@/component/SeoTags/HeadTag"));
const AdSlot300x250 = dynamic(() => import("@/component/Ads/AdSlot300x250"));
const AdSlot728x90 = dynamic(() => import("@/component/Ads/AdSlot728x90"));


const ElectionLive = dynamic(() => import("@/component/ElectionLive"));

const SearchWidget = dynamic(() => import("@/screens/FiveStateElection/SearchWidget"));
const OldTallyWidget = dynamic(() => import("@/screens/FiveStateElection/OldTallyWidget"));
const CandidateStatusWidget = dynamic(() => import("@/screens/FiveStateElection/CandidateStatusWidget"));
const ConstituencyResultMap = dynamic(() => import("@/screens/FiveStateElection/ConstituencyResultMap"));
const ContentGrid = dynamic(() => import("@/screens/FiveStateElection/ContentGrid"));
const ElectionLanding = ({
  categoryNewsListData = null,
  isMobileDevice = false,
  electionPassedCategory = "",
  masterKey = "",
  metaData = {},
  electionLiveData = null,
  stateHindi = "",
  stateName = "",
  faqData = null,
  staticContent = "",
}) => {
  const [currentPage, setCurrentPage] = useState(0);
  const [categoryData, setCategoryData] = useState(
    categoryNewsListData?.content
  );
  const [hasMore, setHasMore] = useState(categoryNewsListData?.is_load_more == 1 ? true : false);
  const [loadingSpinner, setLoadingSpinner] = useState(false);
  const [y, setY] = useState(
    typeof window !== "undefined" && document.scrollingElement.scrollHeight
  );
  const [scrollDirection, setScrollDirection] = useState(
    "you have not scrolled yet"
  );
  const [scrolled, setScrolled] = useState(false);

  const router = useRouter();
  const masterConfig = useContext(MasterConfigContext);
  const currentPath = (router?.asPath || "")?.split("?")[0];
  const categoryPath = currentPath;

  const isBihar = currentPath.includes("bihar");
  const isHaryana = currentPath.includes("haryana");
  const isDelhi = currentPath.includes("delhi");
  const isElectionPath = currentPath.includes("/elections");
  const isElectionLanding = currentPath === "/elections";
  const isAssemblyPath = currentPath === "/elections/assembly-chunav";
  const isAssemblyElectionRoute = currentPath.includes("/elections/assembly-chunav");
  const isBiharElection = currentPath.includes("/elections/assembly-chunav/bihar");
  const [readMore, setReadMore] = useState(true);
  const electionKeys = masterConfig[masterKey];
  const menuList = electionKeys?.menuList;
  const keyBindings = {
    Category:
      currentPath.split("/").length > 2
        ? [currentPath.split("/")[1], currentPath.split("/")[2]]
        : currentPath.split("/")[1],
    Keywords: categoryNewsListData?.seo_detail?.meta_keyword?.split(",") || [],
  };

  useEffect(() => {
    setCategoryData(categoryNewsListData?.content);
  }, [categoryNewsListData?.content]);


  const getMorePost = useCallback(async () => {
    const websiteUrl = process.env.NEXT_PUBLIC_WEBSITE_URL;
    const time = Date.now();
    setLoadingSpinner(true);
    let fetchedData = await getDataFromSSR(
      `${websiteUrl}/api/getCategoryPosts?page=${currentPage}&category=${categoryPath}&display=12&time=${time}`
    );

    if (fetchedData?.data?.categoryNewsListData?.content?.length > 0) {
      setCategoryData((prevData = []) => [
        ...prevData,
        ...fetchedData?.data?.categoryNewsListData?.content,
      ]);
      if (fetchedData?.data?.categoryNewsListData?.is_load_more != 1) {
        setHasMore(false);
      }
    } else {
      setHasMore(false);
    }
    setLoadingSpinner(false);
  }, [currentPage, categoryPath]);

  useEffect(() => {
    if (currentPage < 1) {
      return;
    }
    getMorePost();
  }, [currentPage, getMorePost]);

  const handleNavigation = useCallback(() => {
    if (y > window.scrollY) {
      setScrollDirection("Scrolling Up");
    } else if (y < window.scrollY) {
      setScrollDirection("Scrolling Down");
    }

    setY(window.scrollY);
  }, [y]);

  useEffect(() => {
    window.addEventListener("scroll", handleNavigation);

    return () => {
      window.removeEventListener("scroll", handleNavigation);
    };
  }, [handleNavigation]);

  //   useEffect(() => {
  //   if (
  //     (insightView || mobInsightView) &&
  //     scrollDirection === "Scrolling Down" &&
  //     hasMore &&
  //     !loadingSpinner
  //   ) {
  //     getMorePost({ pagesToFetch: 1, minItemsToAdd: 1 });
  //   }
  // }, [
  //   insightView,
  //   mobInsightView,
  //   scrollDirection,
  //   hasMore,
  //   loadingSpinner,
  //   getMorePost,
  // ]);

  useEffect(() => {
    function handleScroll() {
      if (!scrolled) {
        setScrolled(true);
      }
    }

    window.addEventListener("scroll", handleScroll);

    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, [scrolled]);

  useEffect(() => {
    setTimeout(() => {
      window.googletag = window.googletag || { cmd: [] };

      if (window.screen.width < 900) {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_ATF_300x250",
                [300, 250],
                "div-gpt-ad-1659434453897-0"
              )
              .addService(googletag.pubads());

          }


          if (scrolled) {
            {
              categoryData?.length > 7 && googletag
                .defineSlot(
                  "/1007232/News_tak_Mobile_ROS_MTF-1_300x250",
                  [300, 250],
                  "div-gpt-ad-1659434604998-0"
                )
                .addService(googletag.pubads());
            }
            if (
              // currentSubCategory == electionCategory &&
              categoryData &&
              categoryData?.length > 12
            ) {
              document.getElementById("div-gpt-ad-1659434785315-0") &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Mobile_ROS_MTF-2_300x250",
                    [300, 250],
                    "div-gpt-ad-1659434785315-0"
                  )
                  .addService(googletag.pubads());
            }

            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_BTF_300x250",
                [300, 250],
                "div-gpt-ad-1659435474737-0"
              )
              .addService(googletag.pubads());
          }
          if (!scrolled) {
            googletag
              .defineSlot(
                "/1007232/News_tak_Mobile_ROS_Bottom_320x50",
                [320, 50],
                "div-gpt-ad-1659435612077-0"
              )
              .addService(googletag.pubads());
          }
          // // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
          !scrolled &&
            googletag.cmd.push(function () {
              var INTERSTITIALAd = googletag
                .defineOutOfPageSlot(
                  "/1007232/News_tak_Mobile_ROS_Mweb_Interstitial",
                  googletag.enums.OutOfPageFormat.INTERSTITIAL
                )
                .addService(googletag.pubads());

              googletag.display(INTERSTITIALAd);
            });
        });
      } else {
        googletag.cmd.push(function () {
          if (!scrolled) {
            googletag.destroySlots();
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_ATF_728x90",
                [728, 90],
                "div-gpt-ad-1659424515060-0"
              )
              .addService(googletag.pubads());
            document.getElementById("div-gpt-ad-1707804176041-1") &&
              googletag
                .defineSlot(
                  "/1007232/News_tak_Desktop_ROS_ATF_300x250",
                  [300, 250],
                  "div-gpt-ad-1707804176041-1"
                )
                .addService(googletag.pubads());
          }
          if (scrolled) {

            {
              categoryData &&
                categoryData?.length > 7 &&
                googletag
                  .defineSlot(
                    "/1007232/News_tak_Desktop_ROS_MTF_1_728x90",
                    [728, 90],
                    "div-gpt-ad-1707804176041-2"
                  )
                  .addService(googletag.pubads());
            }
            googletag
              .defineSlot(
                "/1007232/News_tak_Desktop_ROS_BTF_728x90",
                [728, 90],
                "div-gpt-ad-1659425743360-0"
              )
              .addService(googletag.pubads());
          }
          // // googletag.pubads().enableSingleRequest();
          googletag.pubads().disableInitialLoad();
          googletag.enableServices();
          requestBiddingFromPWT();
          Object.keys(keyBindings).forEach((key) => {
            googletag.pubads().setTargeting(key, keyBindings[key]);
          });
        });
      }
      if (scrolled) {
        apstag?.fetchBids(
          {
            slots:
              window.screen.width < 900
                ? createApsSlotsRosMobile({ mtf2: true, mtf3: false })
                : createApsSlotsRosDesktop({ mtf2: false, mtf3: false, btf: true }),
            timeout: 2e3,
          },
          apstagBidCallback
        );
      }
    }, 10);

    try {
      // page query params
      const page = parseInt(router?.query?.page);
      if (page) {
        setCurrentPage(parseInt(page));
      }
    } catch (error) {
      console.error(error);
    }
  }, [scrolled]);

  let [title, description, keywords] = [
    categoryNewsListData?.seo_detail?.meta_title,
    categoryNewsListData?.seo_detail?.meta_description,
    categoryNewsListData?.seo_detail?.meta_keyword,
  ];

  if (isElectionPath) {
    title = categoryNewsListData?.seo_detail?.meta_title || metaData?.title;
    description =
      categoryNewsListData?.seo_detail?.meta_description ||
      metaData?.description;
    keywords =
      categoryNewsListData?.seo_detail?.meta_keyword || metaData?.keywords;
  }

  const firstActive = useMemo(() => {
    let first = false;
    let firstActiveItem = "";

    electionLiveData?.content &&
      Object.keys(electionLiveData?.content).forEach((key) => {
        if (
          first === false &&
          electionLiveData?.content?.[key]?.status === "1"
        ) {
          firstActiveItem = key;
          first = true;
        }
      });

    return firstActiveItem;
  }, [electionLiveData]);
  // console.log("categoryData",categoryData)
  const showCategoryItems = categoryData
  // firstScroll
  //   ? categoryData
  //   : categoryNewsListData?.content;
  const categoryTitle = categoryNewsListData?.title;
  const listTitle = isBiharElection ? "" : categoryTitle;
  const canonicalUrl =
    process.env.NEXT_PUBLIC_WEBSITE_URL +
    (categoryNewsListData?.seo_detail?.canonical_url || currentPath);
  const h1_title = () => {
    if (currentPath === "/elections") {
      return "विधानसभा चुनाव 2026 (Assembly Elections 2026)";
    }
    if (currentPath === "/elections/assembly-chunav") {
      return "विधानसभा चुनाव 2026 (Assembly Elections 2026)";
    }
    if (currentPath === "/elections/assembly-chunav/assam") {
      return "असम विधानसभा चुनाव 2026 (Assam Assembly Election)";
    }
    if (currentPath === "/elections/assembly-chunav/west-bengal") {
      return "पश्चिम बंगाल विधानसभा चुनाव 2026 (West Bengal Assembly Election)";
    }
    if (currentPath === "/elections/assembly-chunav/tamil-nadu") {
      return "तमिलनाडु विधानसभा चुनाव 2026 (Tamil Nadu Assembly Election)";
    }
    if (currentPath === "/elections/assembly-chunav/kerala") {
      return "केरल विधानसभा चुनाव 2026 (Kerala Assembly Election)";
    }
    if (currentPath === "/elections/assembly-chunav/puducherry") {
      return "पुडुचेरी विधानसभा चुनाव 2026 (Puducherry Assembly Election)";
    }
  }
  const showCategoryBanner = masterConfig?.["assembly_widgets_2026"]?.["showCategoryBanner"];
  return (
    <section>
      <HeadTag
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={canonicalUrl}
        noAuthorTag={false}
        image={categoryNewsListData?.seo_detail?.og_image}
        lcpImage={
          categoryNewsListData?.content?.[0]?.image_small
            ? `${categoryNewsListData?.content?.[0]?.image_small}?size=360:203`
            : undefined
        }
      />
      <WebpageSchema
        title={title}
        description={description}
        keywords={keywords}
        canonicalUrl={canonicalUrl}
      />
      <BreadcrumbSchema
        breadcrumbList={categoryNewsListData?.category_detail}
      />
      <ItemsListSchema data={categoryNewsListData?.content} />
      <Breadcrumb breadcrumbList={categoryNewsListData?.category_detail} />
      {faqData && (
        <FaqSchema faqData={faqData?.content?.description_short} />
      )}
      <section>
        <div className="mx-4">
          <div className="hidden md:flex md:items-start md:justify-between md:gap-4">
            <div className="w-full min-h-[90px]">
              <AdSlot728x90
                divId="div-gpt-ad-1659424515060-0"
                minWidth="728px"
                minHeight="90px"
              />
            </div>
          </div>
          <div className="block md:hidden w-full min-h-[250px] max-w-[300px] mx-auto md:mx-0">
            <AdSlot300x250
              divId="div-gpt-ad-1659434453897-0"
              minWidth="300px"
              minHeight="250px"
            />
          </div>
        </div>

        {/* main banner with tab--------------------------------- */}
        {showCategoryBanner && <ElectionMainTab electionKeys={electionKeys} />}
        {(isElectionLanding || isAssemblyElectionRoute) && (
          <>

            {/* <MainBanner electionKeys={electionKeys} /> */}
            {/* {isElectionPath && (
              <Sponsor color="#EE3436" name="चुनाव" electionKeys={electionKeys} />
            )} */}
            {electionKeys?.menuList?.length > 0 && <div className="flex gap-3 flex-row overflow-x-scroll scrollbar-hide mt-2 mx-4 md:mx-4">
              {menuList?.map((item, index) => {
                const isActive =
                  currentPath === menuList[index]?.slug ||
                  menuList[index]?.slug ===
                  `${electionPassedCategory}/constituency-list`;

                const activeClass = isBihar
                  ? "bg-[#CF4C9B] text-white border-2 border-[#CF4C9B]"
                  : isDelhi
                    ? "bg-primary text-white border-2 border-primary"
                    : isHaryana
                      ? "bg-[#64BC46] text-white border-2 border-[#64BC46]"
                      : "bg-primary text-white border-2 border-primary";

                const inactiveClass = isBihar
                  ? "border-2 text-gray-600 hover:text-[#CF4C9B]"
                  : isDelhi
                    ? "border-2 text-gray-600 hover:text-primary"
                    : isHaryana
                      ? "border-2 text-gray-600 hover:text-hrDark"
                      : "border-2 text-gray-600 hover:text-primary";

                return (
                  <a
                    className={`${isActive ? activeClass : inactiveClass
                      } px-3 py-1 rounded-xl whitespace-nowrap flex flex-row items-center gap-1 justify-center`}
                    href={`${process.env.NEXT_PUBLIC_WEBSITE_URL}${menuList[index]?.slug}`}
                    key={item?.slug}
                    target="_self"
                  >
                    {[
                      "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/liveIcon.gif",
                      "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i6.gif",
                      "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i4.gif",
                    ].some((icon) => item?.src?.includes(icon)) ? (
                      <img
                        className="h-4 w-4"
                        src={
                          item?.slug?.includes("-assembl-constituency-result")
                            ? "https://akm-img-a-in.tosshub.com/lingo/newstak/resources/prod/i6.gif"
                            : item?.src
                        }
                        alt={item?.title || "menu icon"}
                      />
                    ) : (
                      <SVG className="h-4 w-4" src={item?.src} />
                    )}
                    <p>{item?.title}</p>
                  </a>
                );
              })}
            </div>}
          </>
        )}


      
          <ExitPollTally masterKey={"assembly_widgets_2026"} stateName={stateName} />
          <StateResultTally masterKey={"assembly_widgets_2026"} stateName={stateName} />
        


        {isMobileDevice && electionLiveData?.content && (
          <div className="top-layer-election mx-4 md:mx-0" style={{ position: "sticky" }}>
            <ElectionLive
              electionLiveData={electionLiveData?.content}
              firstActive={firstActive}
            />
          </div>
        )}

        <ContentGrid content={categoryNewsListData?.content?.slice(0, 6)} heading={h1_title()} />

        {(currentPath === "/elections" || currentPath.includes("/elections/assembly-chunav")) && <SearchWidget stateName={stateHindi || null} />}
        {!(currentPath === "/elections" || currentPath === "/elections/assembly-chunav") &&
          <>  <OldTallyWidget state={stateHindi} />
            <div className="flex flex-col  my-4 mx-2">
              <CandidateStatusWidget state={stateHindi} />
              <ConstituencyResultMap state={stateHindi} />
            </div>
          </>}
        {showCategoryItems?.length >= 7 && scrolled && <div className="mx-3 md:mx-3 md:py-2">
          <AdSlot728x90
            divId="div-gpt-ad-1707804176041-2"
            minWidth="720px"
            minHeight="90px"
          />
        </div>}
        {isMobileDevice ? (
          <div className="mx-3 md:mx-3 md:py-2">
            <List1
              title={""}
              newsListData={showCategoryItems?.slice(6, showCategoryItems?.length)}
              isLCP={true}
              haveH1={false}
              showAds={scrolled}
              election={true}
              scrolled={scrolled}
            />
            {/* <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={mobileInsightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div> */}
          </div>
        ) : (
          <div className="mx-3 md:mx-3 md:px-2 py-2">
            <List2
              title={""}
              newsListData={showCategoryItems?.slice(6, showCategoryItems?.length)}
              isLCP={true}
              showAds={false}
              haveH1={false}
              scrolled={scrolled}
            />
            {/* <div
              className="text-sports news-load h-[50px] w-full mb-4"
              ref={insightref}
            >
              {loadingSpinner === true && (
                <div className="flex items-center justify-center">
                  <div className="animate-spin rounded-full border-t-4 border-primary border-solid h-12 w-12"></div>
                </div>
              )}
            </div> */}
          </div>
        )}
        {
          categoryData?.length >= 12 &&
          hasMore && (
            <div className="justify-items-center">
              <div
                onClick={() => {
                  if (loadingSpinner || !hasMore) return;
                  setCurrentPage(prev => prev + 1);
                }}
                className={`bg-primary
          flex align-middle py-[10px] my-4 px-4 rounded-full 
          justify-center items-center text-white 
          cursor-pointer m-auto w-fit`}
              >
                {loadingSpinner ? "लोड हो रहा..." : "और देखें "}
              </div>
            </div>
          )}
        {categoryNewsListData?.content?.length === 0 &&
          categoryData?.length === 0 && <NoData message="No Data Found" />}

        {scrolled && (
          <div className="mx-4 md:mx-4 ">
            <div className="w-full   max-w-[300px] mx-auto md:mx-0">
              <AdSlot300x250
                divId="div-gpt-ad-1659435474737-0"
                minWidth="300px"
                minHeight="250px"
              />
            </div>
            <div className="w-full   hidden md:block">
              <AdSlot728x90
                divId="div-gpt-ad-1659425743360-0"
                minWidth="720px"
                minHeight="90px"
              />
            </div>
          </div>
        )}


        {/* static content */}
        {staticContent && <div className="my-8 mx-2">
          <h2 className="flex text-xl font-semibold mx-2">
            <span className="w-2 h-[auto] bg-primary inline-block mr-2"></span>
            {stateHindi} 2026 विधानसभा चुनाव
          </h2>

          <div className="my-1 mx-2 bg-[#FFF] dark:bg-[#000] rounded-[10px]">
            <p className={`text-[#323232] text-sm text-left relative inline`}>
              <div className={`${readMore ? "line-clamp-2" : ""}`} dangerouslySetInnerHTML={{ __html: staticContent }} /><span
                onClick={() => {
                  setReadMore((prev) => !prev);
                }}
                className="cursor-pointer inline ml-[5px]  text-primary text-sm"
              >
                {readMore ? "और देखें >" : "< कम देखें"}
              </span>
            </p>
          </div>
        </div>}
        {faqData && (
          <div className="my-2 mx-4">
            <div className="flex">
              <span className="w-2 h-[auto] mr-2 bg-primary"></span>
              <h2 className="text-lg font-semibold">
                विधानसभा चुनाव से जुड़े अक्सर पूछे जाने वाले सवाल (FAQ)
              </h2>
            </div>
            <section className="flex flex-col gap-2 text-gray-500 text-md font-extralight">
              <p
                className={`${isMobileDevice ? "custom-mb-break" : ""}`}
                dangerouslySetInnerHTML={{
                  __html: `${faqData?.content?.description_short}`,
                }}
              />
            </section>
          </div>
        )}

        {(masterConfig?.["assembly_widgets_2026"]?.autoLiveBlog || electionKeys?.autoLiveBlog) && (
          <div className="mx-2">
            <StatesConstituencyLiveResult
              masterKey={electionKeys}
            />
          </div>
        )}
      </section>
    </section>
  );
};

export default ElectionLanding;

